import { render } from "./LogisticDirectorsTableMonitor.vue?vue&type=template&id=4864a8b6"
import script from "./LogisticDirectorsTableMonitor.vue?vue&type=script&lang=js"
export * from "./LogisticDirectorsTableMonitor.vue?vue&type=script&lang=js"

import "./LogisticDirectorsTableMonitor.vue?vue&type=style&index=0&id=4864a8b6&lang=css"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__